import React, { useRef, useState } from "react";
import data from "../../json/Contactus/Contactus2.json";
import toast from "react-hot-toast";
import { sentContact } from "../../api/api";
import EmailTemplate from "../EmailTemplate";
import ReactDOMServer from 'react-dom/server';

const Contactus2 = () => {
  const [contactInfo, setContactInfo] = useState({
    name: "",
    email: "",
    phonenumber: "",
    comments: "",
  });
  const [errors, setErrors] = useState({});
  const submittingRef = useRef(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phonenumber") {
      const numbersOnly = value.replace(/\D/g, "");
      const trimmed = numbersOnly.slice(0, 10);
      setContactInfo({ ...contactInfo, [name]: trimmed });
      setErrors({
        ...errors,
        [name]: trimmed.length === 10 ? "" : "Phone number must be exactly 10 digits"
      });

      return;
    }
    setContactInfo({ ...contactInfo, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submittingRef.current) return; //  Prevent double click instantly
    submittingRef.current = true;// Disable the button
    document.body.style.cursor = "wait";

    const formDataToSend = new FormData();
    const htmlString = ReactDOMServer.renderToStaticMarkup(
      <EmailTemplate data={contactInfo} page="contact" />
    );


    formDataToSend.append(
      "subject",
      `Mail from ${contactInfo.name} `,
    );
    formDataToSend.append('html', htmlString);

    try {
      const response = await sentContact(formDataToSend);

      if (response.data) {

        setContactInfo({
          name: "",
          email: "",
          phonenumber: "",
          comments: "",
        });
        toast.success("Message sent successfully!");

      } else {
        toast(
          response.error.message + ", Message could not be sent" ||
          "Failed to send message"
        );

      }
    } catch (err) {
      toast("An unexpected error occurred");

    }
    finally {
      document.body.style.cursor = "default";
      submittingRef.current = false;
    }
  };

  return (
    <div className="business w-full flex justify-center">
      <div className="2xl:container px-6 py-[72px] md:px-20 flex flex-col gap-y-12 items-center lg:flex-row lg:justify-between" >
        <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start justify-center text-center lg:text-left">
          <div className="w-full md:w-[70%] flex flex-col gap-4">
            <h1 className="text-24 sm:text-32  md:text-48 text-primarycolor font-semibold">{data.Title}</h1>
            <p className=" text-16 md:text-18 text-secondaryblack font-regular">{data.para}</p>
          </div>
          <div className="mt-10 p-3 border-[1px] cursor-pointer bg-white border-ctaorange font-medium hover:bg-btnhover hover:text-white text-18 w-fit rounded-[12px] text-18 font-medium text-ctaorange flex gap-3 mailto">
            <a href="mailto:enquiry@transforma.in">enquiry@transforma.in</a>
          </div>
        </div>
        <div className="w-full mt-10 md:mt-0 sm:w-[80%] lg:w-[40%] flex justify-center bg-white rounded-[24px] border-[1px] border-journyborder shadow-services">
          <form
            onSubmit={(e) => handleSubmit(e)}
            className="flex flex-col gap-4 w-full p-8"
          >
            <h4 className="text-primarycolor md:text-24 text-20 font-semibold w-full text-center pb-6">Contact Our Team</h4>
            <input
              className="h-18 border-[1px] rounded-[12px] border-inputborder p-5 placeholder-secondaryblack text-secondaryblack text-16 font-regular outline-none"
              type="text"
              value={contactInfo.name}
              name="name"
              placeholder="First Name"
              onChange={handleChange}
              required
            />
            {errors.name && <p className="text-red-500 text-14">{errors.name}</p>}
            <input
              className="h-18 border-[1px] rounded-[12px] border-inputborder p-5 placeholder-secondaryblack text-secondaryblack text-16 font-regular outline-none"
              type="email"
              value={contactInfo.email}
              name="email"
              placeholder="Enter your email"
              onChange={handleChange}
              required
            />
            {errors.email && <p className="text-red-500 text-14">{errors.email}</p>}
            <input
              className="h-18 border-[1px] rounded-[12px] border-inputborder p-5 placeholder-secondaryblack text-secondaryblack text-16 font-regular outline-none"
              type="phonenumber"
              value={contactInfo.phonenumber}
              name="phonenumber"
              placeholder="Phone Number"
              onChange={handleChange}
              required
            />
            {errors.phonenumber && <p className="text-red-500 text-14">{errors.phonenumber}</p>}

            <textarea
              className="h-[108px] border-[1px] rounded-[12px] border-inputborder p-5 placeholder-secondaryblack text-secondaryblack text-16 font-regular outline-none"
              value={contactInfo.comments}
              name="comments"
              placeholder="How can we help?"
              onChange={handleChange}
              required
            />
            {errors.comments && <p className="text-red-500 text-14">{errors.comments}</p>}
            <button
              type="submit"
              className="bg-ctaorange text-16  px-4 py-4 text-white font-semibold rounded-[16px] mt-2 hover:bg-btnhover"
            >
              Send your Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contactus2;
